var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChicken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.801,
    height: 9.801,
    viewBox: "0 0 9.801 9.801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bird-solid",
    d: "M0,3.675V3.606a.543.543,0,0,1,.544-.544H4.288A.612.612,0,0,0,4.9,2.45V1.838a1.838,1.838,0,0,1,3.649-.312l1.1.662A.308.308,0,0,1,9.8,2.45a.3.3,0,0,1-.149.262L8.576,3.36v.316A4.287,4.287,0,0,1,5.9,7.649l.783,1.478a.459.459,0,0,1-.812.429L5,7.9a4.151,4.151,0,0,1-.71.059H4.231l.616,1.164a.459.459,0,0,1-.812.429L3.1,7.8A4.286,4.286,0,0,1,0,3.675ZM7.2,2.3a.459.459,0,1,0-.459.459A.459.459,0,0,0,7.2,2.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChicken);
export default __webpack_public_path__ + "static/media/chicken.c11712f931eccf8e24b59169ae25d2f5.svg";
export { ForwardRef as ReactComponent };